import { Toast, toastManager } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/utils/Notifications.tsx
/**
* Notifications are for showing information that is not related the the current screen that the User is viewing.
* Unlike Alerts, Notifications are "informative" about some background process or information to show the user.
*
* An example of a Notification use is when a user receives a new Mail message or Chat.
* An example of an Alert use is when a user hits "save" on a form and it's saved/errored.
*/
var Notifications = {
	/**
	* A short-lived notification
	* @param message
	* @param details
	* @param opts
	*/
	brief: (message, details, opts) => {
		return toastManager(/* @__PURE__ */ jsx(Toast, { children: /* @__PURE__ */ jsx("div", {
			className: "text-left",
			children: message
		}) }), {
			autoClose: 3500,
			hideProgressBar: true,
			position: toastManager.POSITION.TOP_RIGHT,
			...opts || {}
		});
	},
	/**
	* A notification that should "stick" until the user dismisses
	* @param message
	* @param details
	* @param opts
	*/
	persist: (message, details, opts) => {
		return toastManager(/* @__PURE__ */ jsx(Toast, { children: /* @__PURE__ */ jsx("div", {
			className: "text-left",
			children: message
		}) }), {
			autoClose: 0,
			hideProgressBar: true,
			position: toastManager.POSITION.TOP_RIGHT,
			...opts || {}
		});
	}
};
//#endregion
export { Notifications };

//# sourceMappingURL=Notifications.js.map